<template>
  <v-card-title
    height="calc(100vh - 200px)"
    class="d-flex justify-center align-center"
    v-if="!stats"
  >
    {{ loading ? $lang("pleaseWait") : $lang("noItems") }}
  </v-card-title>
  <v-row v-else fill-height class="text-center pa-2">
    <v-col cols="12">
      <v-card-title class="justify-center">{{
        $lang("lastloggedin")
      }}</v-card-title>
      <v-card-text class="oerline">{{
        stats.last_logged_in | fromNow
      }}</v-card-text>
    </v-col>
    <v-col cols="6">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("Attempts")
        }}</v-card-title>
        <v-card-text class="display-3">{{
          stats.prepAttempts_count
        }}</v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("FEEDPOSTS")
        }}</v-card-title>
        <v-card-text class="display-3">{{ stats.feeds_count }}</v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("comments")
        }}</v-card-title>
        <v-card-text class="display-3">{{
          stats.feedComments_count
        }}</v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("reactions")
        }}</v-card-title>
        <v-card-text class="display-3">{{ stats.reactions_count }}</v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("purchasedMocktests")
        }}</v-card-title>
        <v-card-text class="display-3">{{
          stats.purchasedMocktests_count
        }}</v-card-text>
      </v-card>
    </v-col>
    
    <!-- <v-col cols="6">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("doubts")
        }}</v-card-title>
        <v-card-text class="display-3">{{ stats.doubts_count }}</v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card class="" outlined elevation="0">
        <v-card-title class="justify-center">{{
          $lang("doubtAnswers")
        }}</v-card-title>
        <v-card-text class="display-3">{{
          stats.doubtAnswers_count
        }}</v-card-text>
      </v-card>
    </v-col> -->
    
  </v-row>
</template>

<script>
import { axios } from "@/plugins/axios";
export default {
  props: ["user_id"],
  data() {
    return {
      stats: {},
      loading: false,
    };
  },
  methods: {
    fetchUser() {
      this.loading = true;
      axios
        .get("social/stats/" + this.user_id)
        .then((res) => {
          this.stats = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchUser();
  },
};
</script>

<style>
</style>
